import { GetPublicStatusBannerResponse } from '@/types/statusBanner'
import { api } from './api'

export const statusBannerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPublicStatusBanner: builder.query<GetPublicStatusBannerResponse, void>({
      query: () => ({
        url: 'v1/users/status-banner',
        method: 'GET',
      }),
      providesTags: ['StatusBanner'],
    }),
  }),
})

export const { useGetPublicStatusBannerQuery } = statusBannerApi
